export const fr = {
  impactPage: {
    helmet: {
      title: 'Impact',
    },
    header: {
      title: 'Impact chez {{companyName}}',
      subtitle: "L'activité de bénévolat de votre entreprise",
    },
    stats: {
      opportunities: {
        title: 'Total des événements complétées',
        chartLabel: 'Evénements complétées',
      },
      hours: {
        title: 'Total des heures de bénévolat',
        chartLabel: 'Heures de bénévolat',
      },
      signups: {
        title: 'Total des inscriptions au bénévolat',
        chartLabel: 'Inscriptions au bénévolat',
      },
      attendance: {
        title: "Taux d'inscription vs participation",
        chartLabel: 'Taux de participation',
      },
    },
    tables: {
      columns: {
        name: 'Nom',
        volunteerHours: 'Heures de bénévolat',
        opportunitiesCompleted: 'Evénements complétées',
        date: 'Date',
        attendance: 'Participation',
      },
      cards: {
        locations: 'Principaux lieux',
        departments: 'Principaux départements',
        causes: 'Principales causes',
        nonprofits: 'Principaux organismes',
        activeEmployees: 'Employés les plus actifs',
        recentActivity: 'Activité récente',
        initiatives: 'Initiatives',
      },
    },
    filters: {
      buttons: {
        clear: 'Effacer',
      },
    },
    detail: {
      helmet: {
        title: 'Impact › {{metricTitle}}',
      },
      columns: {
        hours: 'Heures',
        opportunitiesCompleted: 'Evénements complétées',
        lastOpportunity: 'Dernière événement',
        name: 'Nom',
        signUps: 'Inscriptions',
        attendanceRate: 'Taux de participation',
        topCauses: 'Principales causes',
        topNonprofits: 'Principaux organismes',
        department: 'Département',
        date: 'Date',
        attendance: 'Participation',
        nonprofit: 'Organisme',
        causes: 'Causes',
        topDepartments: 'Principaux départements',
      },
      metrics: {
        topLocations: 'Principaux lieux',
        topDepartments: 'Principaux départements',
        topCauses: 'Principales causes',
        topNonprofits: 'Principaux organismes',
        activeEmployees: 'Employés les plus actifs',
        recentActivity: 'Activité récente',
        topCausePillars: 'Principaux Initiatives',
      },
      emptyState: {
        title: 'Aucune donnée',
        description:
          "Il semble que vous n'ayez pas encore de données. Essayez de modifier vos filtres",
      },
    },
    exportsModal: {
      title: "Paramètres d'exportation",
      selectAll: 'Tout sélectionner',
      clearAll: 'Tout effacer',
      cta: 'Exporter',
      description:
        "Personnalisez les données que vous souhaitez inclure avant de télécharger un CSV avec les statistiques d'impact de votre entreprise",
      groupBy: {
        label: 'Grouper par',
        description:
          'Votre sélection déterminera si les données exportées affichent les statistiques par utilisateur ou par événement.',
        user: 'Utilisateur',
        event: 'Événement',
      },
      filters: {
        noFiltersDesc:
          "Vous n'avez aucun filtre ajouté. Vous pouvez toujours ajouter des filtres personnalisés en appuyant sur le menu Filtres.",
        youHave: 'Vous avez',
        filtersApplied: 'filtre(s) appliqué(s).',
      },
      columns: {
        label: 'Colonnes',
        guestsDesc: "Inclure les heures des invités qui n'ont pas de compte Purposely",
        hoursDesc:
          "Le nombre total d'heures de bénévolat contribuées par cet utilisateur",
        eventsDesc:
          "Le nombre total d'événements auxquels cet utilisateur a participé",
        attendanceDesc:
          "Le pourcentage d'événements auxquels cet utilisateur a participé",
        locationDesc: "Où se trouve l'utilisateur",
        departmentDesc: "Le département de l'utilisateur",
        workHoursDesc:
          "Le nombre total d'heures VDFC et Journées de soins contribuées par cet utilisateur",
        nonprofitDesc:
          'Chaque organisme sans but lucratif avec lequel votre entreprise a fait du bénévolat recevra sa propre colonne et la valeur associée représentera le total des heures/événements de bénévolat par utilisateur',
        causesDesc:
          'Chaque cause pour laquelle votre entreprise a fait du bénévolat recevra sa propre colonne et la valeur associée représentera le total des heures/événements de bénévolat par utilisateur',
        fields: {
          guest_hours: 'Heures des invités',
          total_hours: 'Total des heures',
          total_events: 'Total des événements',
          attendance_rate: 'Taux de participation',
          city: 'Ville',
          region: 'Région',
          country: 'Pays',
          department: 'Département',
          vdfc: 'Heures VDFC',
          care_days: 'Heures Journées de soins',
          hours_per_nonprofit: 'Heures par organisme sans but lucratif',
          events_per_nonprofit: 'Événements par organisme sans but lucratif',
          hours_per_cause: 'Heures par cause',
          events_per_cause: 'Événements par cause',
        },
      },
    },
  },
}
